import { createStore } from 'satcheljs';
import OptionsSearchStore from './schema/OptionsSearchStore';

export default createStore<OptionsSearchStore>('optionsSearchStore', {
    query: '',
    suppressFailedSearchDatapoints: false,
});
